import React, { useState, useEffect } from 'react';
import {MidiAccessStatus} from "./utils";

export default function MidiInterfaceLoader({ setSMidiAccessStatus, midiOutputs, setMidiOutputs, midiInputs, setMidiInputs }) {
    const [initialised, setInitialised] = useState(false);

    useEffect(() => {
        if (initialised) {
            return;
        }
        if (navigator.requestMIDIAccess) {
            navigator.requestMIDIAccess({ sysex: true })
                .then((midiAccess) => {
                    const outputs = Array.from(midiAccess.outputs.values());
                    setMidiOutputs && setMidiOutputs(outputs);
                    const inputs = Array.from(midiAccess.inputs.values());
                    setMidiInputs && setMidiInputs(inputs);
                    setSMidiAccessStatus && setSMidiAccessStatus(MidiAccessStatus.success);
                    setInitialised(true);
                })
                .catch((err) => {
                    console.log("MIDI access denied", err);
                    setSMidiAccessStatus && setSMidiAccessStatus(MidiAccessStatus.denied);
                });
        } else {
            console.log("This browser does not support WebMIDI");
            setSMidiAccessStatus && setSMidiAccessStatus(MidiAccessStatus.unsupported);
        }
    }, [initialised, midiOutputs, midiInputs, setSMidiAccessStatus, setMidiOutputs, setMidiInputs]);

    return (
        <></>
    );
}